<template>
    <div style="display: inline">{{ display }}</div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class HourDisplay extends Vue {
    @Prop() private dateTime!: Date;
    @Prop() private dateTimeFormat?: string;
    private display: string = '';

    constructor() {
        super();
        this.display = moment(this.dateTime).format(this.dateTimeFormat ? this.dateTimeFormat : 'HH:mm');
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
